export default {
  全部行业分类: 'All Industries',
  首页: 'Home',
  云上展览: 'Virtual Exhibitions',
  全球展览: 'Global Exhibitions',
  国内展览: 'Domestic Exhibitions',
  国外展览: 'Overseas Exhibitions',
  全球会议: 'Global Conferences',
  国内会议: 'Domestic Conferences',
  国外会议: 'Overseas Conferences',
  云展系统: 'Companies',
  企业展品: 'Exhibits',
  企业名片: 'Business Card',
  企业云展: 'Manage My Company Page',
  招标类型: 'Category',
  招标地区: 'Location',
  招标服务: 'Tender Service',
  现场直播: 'Live Streams',
  企业直播: 'Live Streams',
  产业头条: 'Industry Headlines',
  资讯服务: 'Information Service',
  营销工具: 'Marketing Tools',
  海报制作: 'Poster Templates',
  共享设计: 'Designs & Templates',
  展厅模型: 'Exhibition Space Designs',
  工程商: 'Contractors',
  设计师: 'Designers',
  请输入搜索内容: 'Please enter some search keyword.',
  免费发布: 'Create Post',
  发布云上展览: 'Post Virtual Exhibition',
  发布线下展览: 'Post Offline Exhibition',
  发布全球会议: 'Post Conference',
  发布模型: 'Upload Design',
  发布海报: 'Upload Poster Template',
  发布展品: 'Add New Exhibits',

  // 改版的标题
  云会展: 'Cloud Exhibitions',
  全球展: 'Global Exhibitions',
  云会议: 'Global Conferences',
  云企业: 'Cloud Enterprise',
  云数据: 'Cloud Data',
  云招聘: 'Recruitment',
  云产品: 'Cloud Products',
  云招标: 'Tender Service',
  云直播: 'Live Streams',
  云头条: 'Headlines',
  云海报: 'Poster Templates',
  云设计: 'Cloud Design',
  云模型: 'Exhibition Space Designs',
  已发布的会议: 'My Conferences',
  已发布的展览: 'My Exhibitions',
  输入关键词寻找: 'Enter keyword search',
  搜索: 'Search',
  数字孪生: 'Digital Twins',
  大数据获客: 'Big-Data Client Access',
  人工智能: 'Artificial Intelligence',
  分类目录: 'Category List',
  欢迎来到云展动力: 'welcome to Cloud Exhibition',
  云展动力: 'Cloud Exhibition',
  采购需求: 'Sourcing Needs',
  更多: 'More',
  发布了采购招标需求: 'posted a tender request',
}
